<template>
  <v-container
    lcd
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <v-flex
        xs12
      >
        <material-card
          title="CTQ Analyzer"
          class="card-shrink card-padding v-card__first"
          color="general"
        >
          <!-- <v-icon
            :class="{'card-shrink-active-icon' : shrink_1}"
            @click="shrink_1=!shrink_1"
          >mdi-apple-keyboard-control</v-icon> -->
          <v-form>
            <v-container
              py-0
              class="mw-100">
              <v-layout wrap>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg1>
                  <v-autocomplete
                    v-model="summaryFactory"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryFactoryMenu"
                    label="Vendor"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg2>
                  <v-autocomplete
                    v-model="summaryPartNum"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryPartNumMenu"
                    label="PART NUMBER"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                    <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg1>
                  <v-autocomplete
                    v-model="summarystage"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summarystageMenu"
                    label="STAGE"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  d-flex
                  align-items-center
                  xs12
                  lg6>
                  <p class="m-0">Time Interval</p>
                  <v-menu
                    v-model="summaryRangeStartDateMenu"
                    :close-on-content-click="false"
                    :nudge-left="40"
                    lazy
                    transition="scale-transition"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="summaryRangeStartDate"
                      label=""
                      prepend-icon="event"
                    />
                    <v-date-picker
                      v-model="summaryRangeStartDate"
                      :min="startdate"
                      :max="new Date() | date-format"
                       :events="highlightedDates"
                      :event-color="getEventColor"
                      :color="theme==='dark'?'danger':'general'"
                      type="date"
                      no-title
                      scrollable
                      actions/>
                  </v-menu>
                  <p class="m-0 text-center px-3">到</p>
                  <v-menu
                    v-model="summaryRangeEndDateMenu"
                    :close-on-content-click="false"
                    :nudge-left="40"
                    lazy
                    transition="scale-transition"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="summaryRangeEndDate"
                      label=""
                      prepend-icon="event"
                    />
                    <v-date-picker
                      v-model="summaryRangeEndDate"
                      :min="summaryRangeStartDate"
                      :max="new Date() | date-format"
                       :events="highlightedEndDates"
                      :event-color="getEndEventColor"
                      :color="theme==='dark'?'danger':'general'"
                      type="date"
                      no-title
                      scrollable
                      actions/>
                  </v-menu>
                </v-flex>
                 <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg1
                  text-xs-right
                  d-flex
                  align-items-center
                >
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="general"
                    @click="downloadCSV()"
                  >
                    <v-icon class="mr-2">mdi-export</v-icon>Export data
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="processingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        PROCESSING 處理中
      </p>
    </v-dialog>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import qs from 'qs'
// import Vue from 'vue'
// import VueC3 from 'vue-c3'
// import 'c3/c3.min.css'
import { mapState } from 'vuex'
import Loading from '@/assets/img/loading.gif'
// import WeekPicker from '@/components/module/datepicker/WeekPicker.vue'

export default {
  name: 'CTQNPIAnalyzer',
  //   components: {
  //     WeekPicker
  //   },
  data () {
    return {
      startdate: '2018-04-01',
      highlightedDates: ['2025-02-10', '2025-02-14', '2024-02-20'],
      highlightedEndDates: ['2025-02-08', '2025-02-13', '2024-02-14'],
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      processingView: false,
      // summaryCaseName: '',
      // summaryDate: '',
      // summaryEMS: '',
      // summaryEMSpk: 0,
      // summaryRange: '5',
      // summaryItem: 'CPU_TEMP',
      summaryTableShowList: [],
      // nullDatetime: null,
      // datetime: new Date(),
      // datetimeString: '2019-01-01 12:00',
      // formattedDatetime: '09/01/2019 12:00',
      // textFieldProps: {
      //   appendIcon: 'event'
      // },
      // dateProps: {
      //   headerColor: 'red'
      // },
      // timeProps: {
      //   useSeconds: false,
      //   ampmInTitle: true,
      //   format: '24hr',
      //   allowedMinutes: m => m % 30 === 0
      // },
      showBrightness: true,
      shrink_1: true,
      summaryRangeStartDateMenu: false,
      summaryRangeStartDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      summaryRangeEndDateMenu: false,
      summaryRangeEndDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      summaryFactoryMenu: [],
      summaryFactory: '',
      tempFactory: '',
      summaryPartNumMenu: [],
      summaryPartNum: '',
      tempPartNum: '',
      summaryprocessMenu: [],
      summaryprocess: '',
      tempprocess: '',
      summarystationMenu: [],
      summarystation: '',
      tempstation: '',
      summaryparameternameMenu: [],
      summaryparametername: '',
      tempparametername: '',
      summaryperiodtypeMenu: [],
      summaryperiodtype: '',
      tempperiodtype: '',
      summarystageMenu: [],
      summarystage: '',
      tempstage: '',
      contentDateList: [],
      summaryDateList: [],
      summaryDateStart: '',
      showDownLoadBtn: true,
      // biosSn: '',
      // i1Sn: '',
      // mfrid: '',
      // mfrdate: '',
      // errorCode: '',
      // yRangeType: '',
      // yRangeStart: '',
      // yRangeEnd: '',
      // xyCoordinateRangeType: '',
      // xCoordinateRangeStart: '',
      // xCoordinateRangeEnd: '',
      // yCoordinateRangeStart: '',
      // yCoordinateRangeEnd: '',
      // gammaRangeStart: '',
      // gammaRangeEnd: '',
      // gammaDiffRangeStart: '',
      // gammaDiffRangeEnd: '',
      summary: {
        biosSn: '',
        i1Sn: '',
        mfrid: '',
        mfrdate: '',
        errorCode: '',
        yRangeType: '',
        yRangeStart: '',
        yRangeEnd: '',
        xyCoordinateRangeType: '',
        xCoordinateRangeStart: '',
        xCoordinateRangeEnd: '',
        yCoordinateRangeStart: '',
        yCoordinateRangeEnd: '',
        gammaRangeStart: '',
        gammaRangeEnd: '',
        gammaDiffRangeStart: '',
        gammaDiffRangeEnd: ''
      },
      // RangeAll: true,
      // RangeIndex: 999,
      // RangeMin: 0,
      // RangeMax: 9999,
      // RangeMaxList: {
      //   CPU_TEMP: 200,
      //   GPU_TEMP: 200,
      //   CPU_POWER: 200,
      //   GPU_POWER: 200
      // },
      // OverRangeCount: 0,
      // RangeCount: 1,
      passAmount: '0',
      failAmount: '0',
      totalTestInputs: '0',
      submit: false,
      IsSubmitPage: true,
      isSorting: false,
      responseData: [],
      responseDataOnly: [],
      isInitialPageLoad: true
      // handler_bar: new Vue()
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink'])
    // pages () {
    //   if(this.responseData.length > 0) {
    //     return this.pagination.rowsPerPage ? Math.ceil(this.responseData.length / this.pagination.rowsPerPage) : 10
    //   }
    // },
    // options_bar () {
    //   return {
    //     data: {
    //       x: 'x',
    //       columns: [
    //         this.barXaxisName,
    //         this.barXaxisValue
    //       ],
    //       labels: true,
    //       // labels: {
    //       //   // format: function (v, id, i, j) { return v + '%' }
    //       // },
    //       // onclick: function (d) { alert(d.index) },
    //       onclick: (d) => { this.summaryList(d.index, 'range') },
    //       type: 'bar',
    //       types: {
    //         'NormalDistribution': 'spline'
    //       },
    //       axes: {
    //         'ModelName': 'y'
    //       }
    //       // colors: {
    //       //   ModelName: '#999999'
    //       // }
    //       // onclick: (d, i) => { this.summaryList(d, i) } // {id: "data23", value: 120, ratio: 0.8, index: 1, name: "data23"}
    //       // color: function (color, d) {
    //       //   // d will be 'id' when called for legends
    //       //   return d.value >= 5.0 ? '#ff0000' : d.value >= 3.0 ? '#ff9800' : color
    //       // }
    //       // color: (color, d) => {
    //       //   // d will be 'id' when called for legends
    //       //   return (this.OverRangeCount > 0 && d.index === this.barXaxisName.length - 2) ? '#ffa500' : color
    //       // }
    //     },
    //     axis: {
    //       x: {
    //         type: 'category', // this needed to load string x value
    //         tick: {
    //           rotate: -45,
    //           multiline: false
    //         }
    //         // label: {
    //         //   text: '期',
    //         //   position: 'outer-center'
    //         // }
    //       },
    //       y: {
    //         // max: this.RangeCount,
    //         // min: 0,
    //         // tick: {
    //         //   // count: this.RangeCount + 1
    //         // },
    //         // padding: {
    //         //   top: 0,
    //         //   bottom: 0
    //         // }
    //         // tick: {
    //         //   format: function (value) { return value + '%' }
    //         // }
    //         // label: {
    //         //   text: '%',
    //         //   position: 'outer-middle'
    //         // }
    //       },
    //       y2: {
    //         // show: true
    //         // label: {
    //         //   text: '億',
    //         //   position: 'outer-middle'
    //         // }
    //       }
    //     },
    //     tooltip: {
    //       format: {
    //         title (d) {
    //           // return `第 ${d} 期`
    //         },
    //         value (value, ratio, id) {
    //           // return `${value} 億`
    //         }
    //       }
    //     },
    //     grid: {
    //       x: {
    //         show: true
    //       },
    //       y: {
    //         show: true
    //       }
    //     },
    //     legend: {
    //       position: 'bottom',
    //       padding: 16,
    //       show: false
    //     },
    //     size: {
    //       // width: 640,
    //       height: 500
    //     }
    //   }
    // }
  },
  watch: {
    summaryFactory (val) {
      // this.summaryPartNumMenu = [
      //   { text: 'Test123_UX5406ZA', value: 'Test123_UX5406ZA' },
      //   { text: 'Test456_X515EA', value: 'Test456_X515EA' }
      // ]
      // this.summaryprocess = ''
      // this.summarystation = ''
      // this.summarystation = ''
      // this.summaryperiodtype = ''
      // if (this.tempPartNum !== '' && this.isInitialPageLoad) {
      //   this.summaryPartNum = this.tempPartNum
      // }
      const body = {
        vendorCode: this.summaryFactory
      }
      this.$http.get('/api/ctq/part/model/getPartNumberByVendorCode?' + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            const data = res.data
            this.summaryPartNumMenu = data.map(item => ({
              text: item.partNumber + ' (' + item.modelName + ')',
              value: item.partNumber
            }))
            this.summaryprocess = ''
            this.summarystation = ''
            this.summarystation = ''
            this.summaryperiodtype = ''
            if (this.tempPartNum !== '' && this.isInitialPageLoad) {
              this.summaryPartNum = this.tempPartNum
            }
          }
        })
    },
    summaryPartNum (val) {
      const body = {
        vendorCode: this.summaryFactory,
        partNumber: val
      }
      this.$http.get(`/api/ctq/test/spec/getStage?` + qs.stringify(body)).then(res => res.data)
        .then(res => {
          console.info(res)
          if (res.status === 'success') {
            const data = res.data
            this.summarystageMenu = data.map(item => ({
              text: item.stage,
              value: item.stage
            }))
            if (this.tempstage !== '' && this.isInitialPageLoad) {
              this.summarystage = this.tempstage
            }
          }
        })
    },
    summarystage (val) {
      const body = {
        vendorCode: this.summaryFactory,
        partNumber: this.summaryPartNum,
        stage: val
      }
      this.$http.post(`/api/ctq/test/statistic/getNPIDate`, body).then(res => res.data)
        .then(res => {
          console.info(res)
          if (res.status === 'success') {
            const dates = res.data.map(item => item.npiDate)
            this.highlightedDates = dates
            this.highlightedEndDates = dates
          }
        })
    },
    summaryRangeStartDate (val) {
      this.summaryRangeStartDateMenu = false
      // this.startTimeMenu = true
    },
    summaryRangeEndDate (val) {
      this.summaryRangeEndDateMenu = false
      // this.endTimeMenu = true
    }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/ctqnpi/CTQNPIAnalyzer')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          if (this.$route.params.factory && this.$route.params.project && this.$route.params.process && this.$route.params.station && this.$route.params.parametername && this.$route.params.periodtype && !this.isPageReload()) {
            this.tempFactory = Number(this.$route.params.factory)
            this.tempPartNum = this.$route.params.project
            this.tempprocess = this.$route.params.process
            this.tempstation = this.$route.params.station
            this.tempparametername = this.$route.params.parametername
            this.tempperiodtype = this.$route.params.periodtype
          }
          sessionStorage.removeItem('cacheFilterInfo')
          const body = {
            type: 'mepart'
          }
          this.$http.get('/api/system/pmsPath/getCodeAndNameListByType?' + qs.stringify(body)).then(res => res.data)
            .then(res => {
              if (res.status === 'success') {
                const data = res.data
                this.summaryFactoryMenu = data.map(item => ({
                  text: item.name,
                  value: item.code
                }))
                if (this.tempFactory !== '') {
                  this.summaryFactory = this.tempFactory
                }
              }
            })
          // this.doResponseColumnDefine()
          // this.summaryFactoryMenu = [
          //   { text: 'JT_NJ', value: '00' },
          //   { text: 'DCB-CQ', value: '01' },
          //   { text: 'MOGOLD-SZ', value: '02' },
          //   { text: 'YUCHIA-NT', value: '03' },
          //   { text: 'CTC-KS', value: '04' },
          //   { text: 'VITO-SQ', value: '05' }
          // ]
          this.summaryperiodtypeMenu = [
            { text: '年', value: 'year' },
            { text: '季', value: 'season' },
            { text: '月', value: 'month' },
            { text: '周', value: 'week' }
          ]
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    openctqplot (pk, statisticTestItemType) {
      const routeData = this.$router.resolve({
        path: '/ctq/CTQAnalyzer/ShowCTQNormaldistributionplot',
        query: {
          pk,
          statisticTestItemType
        }
      })

      window.open(routeData.href, '_blank')
    },
    selectedDate (val) {
      this.summaryDateStart = val
    },
    isPageReload () {
      if (performance.getEntriesByType && performance.getEntriesByType('navigation').length > 0) {
        return performance.getEntriesByType('navigation')[0].type === 'reload'
      } else if (performance.navigation) {
        return performance.navigation.type === 1
      }
      return false
    },
    getEventColor (date) {
      return this.highlightedDates.includes(date) ? 'green' : ''// 蓝色小圆点
    },
    getEndEventColor (date) {
      return this.highlightedEndDates.includes(date) ? 'green' : ''// 蓝色小圆点
    },
    doResponseColumnDefine () {
      // this.responseHeaders.push({
      //   align: '',
      //   class: 'table-width-55',
      //   fixed: true,
      //   sortable: false,
      //   text: '標記',
      //   value: ''
      // })
      // this.responseHeadersOnly.push({
      //   align: '',
      //   class: 'table-width-55',
      //   fixed: true,
      //   sortable: false,
      //   text: '標記',
      //   value: ''
      // })
      console.log('responseColumnDefine:', this.responseColumnDefine)
      console.log('responseTableShowListOnly:', this.responseTableShowListOnly)
      this.responseHeadersList = []
      this.responseHeaders = []
      this.responseHeadersOnly = []
      this.responseTableShowList = {}
      this.responseTableShowListOnly = {}
      this.responseColumnClassList = {}
      this.responseAlignList = {}
      this.summaryTableShowList = []
      this.responseColumnDefine.forEach((r) => {
        if (r.fixed) {
          this.responseHeaders.push(r)
          this.responseHeadersOnly.push(r)
        } else {
          this.responseHeadersList.push(r)
          this.responseTableShowList[r.value] = r.fixed
          this.responseTableShowListOnly[r.value] = r.fixed
          this.responseColumnClassList[r.value] = r.class
          this.responseAlignList[r.value] = r.align
          this.summaryTableShowList.push({ text: r.text, value: r.value })
        }
      })
      console.log('responseHeaders:', this.responseHeaders)
      console.log('responseTableShowList:', this.responseTableShowList)
      console.log('responseTableShowListOnly:', this.responseTableShowListOnly)
    },
    // doBeforeLink (TtrsPk, deviceSn) {
    //   this.$http.post('/api/thermal/getSingleDeviceBurnInDataStatistic?ttrsPk=' + TtrsPk).then(res => res.data)
    //     .then(res => {
    //       if (res.status === 'success') {
    //         let Groups = res.data.fanTestData.length
    //         const routeData = this.$router.resolve({ path: '/thermal/singleDeviceBurnInDataStatistic/' + TtrsPk + '/' + Groups, query: { sn: deviceSn, modelname: this.summaryCaseName, date: this.summaryDate, ems: this.summaryEMS } })
    //         window.open(routeData.href, '_blank')
    //       }
    //     })
    // },
    // doSummary (type) {
    //   this.barXaxisName = ['x']
    //   this.barXaxisValue = ['ModelName']
    //   let AllArray = []
    //   this.responseDataOnly.forEach((r) => {
    //     if (r[this.summaryItem] >= 0) {
    //       AllArray.push(r[this.summaryItem])
    //     }
    //   })
    //   this.RangeMax = Math.ceil(Math.max(...AllArray) / this.summaryRange) * this.summaryRange
    //   this.RangeMin = Math.floor(Math.min(...AllArray) / this.summaryRange) * this.summaryRange
    //   if (this.RangeMax > this.RangeMaxList[this.summaryItem]) {
    //     this.RangeMax = Math.min(this.RangeMax, this.RangeMaxList[this.summaryItem])
    //   }
    //   this.OverRangeCount = 0
    //   const RangeArray = []
    //   for (let i = this.RangeMin; i < this.RangeMax; i = i + this.summaryRange) {
    //     RangeArray[(i - this.RangeMin) / this.summaryRange] = 0
    //   }
    //   AllArray.forEach((r) => {
    //     if (r > this.RangeMaxList[this.summaryItem]) {
    //       this.OverRangeCount = this.OverRangeCount + 1
    //     } else {
    //       if (RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] > 0) {
    //         RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] = RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] + 1
    //       } else {
    //         RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] = 1
    //       }
    //     }
    //   })

    //   this.RangeCount = Math.max(...RangeArray)
    //   for (let i = 0; i < RangeArray.length; i++) {
    //     this.barXaxisValue.push(RangeArray[i] || 0)
    //     switch (true) {
    //       case (this.summaryRange === '5' || this.summaryRange === '10'):
    //         this.barXaxisName.push((this.RangeMin + (i * this.summaryRange)).toFixed(0) + '-' + (this.RangeMin + ((i + 1) * this.summaryRange)).toFixed(0))
    //         break
    //       case (this.summaryRange === '2.5' || this.summaryRange === '7.5'):
    //         this.barXaxisName.push((this.RangeMin + (i * this.summaryRange)).toFixed(1) + '-' + (this.RangeMin + ((i + 1) * this.summaryRange)).toFixed(1))
    //         break
    //       // default:
    //       // return
    //     }
    //   }
    //   if (this.OverRangeCount > 0) {
    //     this.barXaxisValue.push(this.OverRangeCount)
    //     this.barXaxisName.push('>' + this.RangeMaxList[this.summaryItem])
    //   }
    //   // RangeArray.forEach((r, index) => {
    //   //   console.log(r)
    //   //   console.log(index)
    //   //   this.barXaxisValue.push(r)
    //   //   this.barXaxisName.push((this.RangeMin + (index * this.summaryRange)) + '-' + (this.RangeMin + ((index + 1) * this.summaryRange)))
    //   // })
    //   if (type === 'init') {
    //     this.handler_bar.$emit('init', this.options_bar)
    //   } else {
    //     this.handler_bar.$emit('dispatch', chart => {
    //       const options = {
    //         columns: [
    //           this.barXaxisName,
    //           this.barXaxisValue
    //         ]
    //       }
    //       chart.load(options)
    //     })
    //   }
    // },
    checkTableShowListAll () {
      this.checkTableShowList = []
      this.summaryTableShowList.forEach((s) => {
        this.checkTableShowList.push(s.value)
      })
    },
    checkTableShowListClear () {
      this.checkTableShowList = []
    },
    doSubmit () {
      if (this.doSubmitVerification()) {
        this.loadingView = true
        this.pagination.page = 1
        this.pagination.current.rowsPerPage = 25
        if (this.summaryperiodtype === 'year' || this.summaryperiodtype === 'season') {
          this.showDownLoadBtn = false
        } else {
          this.showDownLoadBtn = true
        }
        this.doCTQDataList()
        // setTimeout(() => {
        //   this.loadingView = false
        // }, 0)
        const Url = '/ctq/CTQAnalyzer/' + this.summaryFactory + '/' + this.summaryPartNum + '/' + this.summaryprocess + '/' + this.summarystation + '/' + this.summaryparametername + '/' + this.summaryperiodtype
        if (this.$router.history.current.path !== Url) {
          this.$router.replace(Url)
        }
        // Object.keys(this.summary).forEach(key => {
        //   this.summary[key] = ''
        // })
      }
    },
    doSubmitVerification () {
      const start = new Date(this.summaryRangeStartDate)
      const end = new Date(this.summaryRangeEndDate)

      // 開始日期 + 3 個月
      const maxEnd = new Date(start)
      maxEnd.setMonth(maxEnd.getMonth() + 3)
      if (this.summaryFactory === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Vendor'
        return false
      } else if (this.summaryPartNum === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇PART NUMBER'
        return false
      } else if (this.summarystage === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Stage'
        return false
      } else if (end > maxEnd) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '日期範圍不能超過3個月'
        return false
      } else {
        return true
      }
    },
    doCTQSaveFilterInfo () {
      const body = {
        vendorCode: this.summaryFactory,
        factoryName: this.summaryFactoryMenu[this.summaryFactoryMenu.map(e => { return e.value }).indexOf(this.summaryFactory)].text || null,
        partNumber: this.summaryPartNum,
        processCode: this.summaryprocess,
        process: this.summaryprocessMenu[this.summaryprocessMenu.map(e => { return e.value }).indexOf(this.summaryprocess)].text || null,
        stationCode: this.summarystation,
        station: this.summarystationMenu[this.summarystationMenu.map(e => { return e.value }).indexOf(this.summarystation)].text || null,
        testItemCode: this.summaryparametername,
        parametername: this.summaryparameternameMenu[this.summaryparameternameMenu.map(e => { return e.value }).indexOf(this.summaryparametername)].text || null,
        statisticTimeType: this.summaryperiodtype,
        periodtype: this.summaryperiodtypeMenu[this.summaryperiodtypeMenu.map(e => { return e.value }).indexOf(this.summaryperiodtype)].text || null,
        statisticTimeValue: this.summaryDateStart,
        searchdate: this.contentDateList[this.contentDateList.map(e => { return e.value }).indexOf(this.summaryDateStart)].text || null,
        project: this.modelnameList.join(','),
        year: (() => {
          const str = this.summaryDateStart || ''
          // 判断第一个字符是否是字母
          if (/^[a-zA-Z]/.test(str)) {
            // 首位是字母：从第2位开始取4位
            return str.substring(1, 5)
          } else {
            // 不是字母：直接取前4位
            return str.substring(0, 4)
          }
        })(),
        responseData: this.responseDataOnly
      }
      localStorage.setItem('ctqFilterInfo', JSON.stringify(body))
      // localStorage.setItem('lcdFilterUpdateTime', this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss'))
    },
    doCTQDataList () {
      this.submit = true
      const body = {
        vendorCode: this.summaryFactory,
        partNumber: this.summaryPartNum,
        processCode: this.summaryprocess,
        stationCode: this.summarystation,
        testItemCode: this.summaryparametername,
        statisticTimeType: this.summaryperiodtype,
        statisticTimeValue: this.summaryDateStart
        // year: (() => {
        //   const str = this.summaryDateStart || ''
        //   // 判断第一个字符是否是字母
        //   if (/^[a-zA-Z]/.test(str)) {
        //     // 首位是字母：从第2位开始取4位
        //     return str.substring(1, 5)
        //   } else {
        //     // 不是字母：直接取前4位
        //     return str.substring(0, 4)
        //   }
        // })()
      }
      console.info(body)
      this.$http.post(`/api/ctq/test/statistic/getStatisticData`, body).then(res => res.data)
        .then(res => {
          console.info(res)
          if (res.status === 'success') {
            const typeMap = {
              4: '實測',
              5: '實測最小',
              6: '實測最大'
            }

            const data = (res.data || []).map(item => ({
              ...item,
              typeName: typeMap[item.statisticTestItemType] || '',
              min: item.min != null ? item.min.toFixed(2) : '',
              max: item.max != null ? item.max.toFixed(2) : ''
            }))
            this.responseData = data
            this.responseDataOnly = data

            // this.responseData = res.data
            // this.responseDataOnly = res.data
            this.modelnameList = [...new Set(res.data.map(item => item.modelName))]
            this.doCTQSaveFilterInfo()
            this.doResponseColumnDefine()
            this.pagination.current.totalItems = 5
            this.pages = 1
            this.loadingView = false
          }
        })
    },

    downloadCSV () {
      if (this.doSubmitVerification()) {
        this.processingView = true
        const userpk = JSON.parse(localStorage.getItem('user')).userPk
        const body = {
          vendorCode: this.summaryFactory,
          partNumber: this.summaryPartNum,
          startTime: this.summaryRangeStartDate,
          endTime: this.summaryRangeEndDate,
          userPk: userpk,
          periodType: this.summaryperiodtype,
          stage: this.summarystage
        }
        this.$http.post('/api/ctq/test/record/downloadDetails', body).then(res => res.data)
          .then(res => {
            this.processingView = false
            if (res.status === 'success') {
              this.snackbar = true
              this.snackbarColor = 'green'
              this.snackbarMsg = '下載成功，數據處理中...處理完成後會寄到您的郵箱中，請注意查收'
            } else {
              this.snackbar = true
              this.snackbarColor = 'red'
              this.snackbarMsg = '下載失敗，請通知系統管理員'
            }
          })
          .catch(err => {
            this.processingView = false
            this.snackbar = true
            this.snackbarColor = 'orange'
            this.snackbarMsg = err
          })
      }
    },
    getSummaryDateRangeByList (summaryDateStart) {
      if (!summaryDateStart) return null

      const item = this.contentDateList.find(
        x => x.value === summaryDateStart
      )

      if (!item) return null

      let startTime = null
      let endTime = null

      // ================= MONTH =================
      // text: "2026-01"
      const monthMatch = summaryDateStart.match(/^(\d{4})M(\d{2})$/)

      if (monthMatch) {
        const year = parseInt(monthMatch[1])
        const month = parseInt(monthMatch[2])

        startTime = new Date(year, month - 1, 1)

        // 當月最後一天
        endTime = new Date(year, month, 0)
      }

      // ================= WEEK =================
      // text: "2026 W02 (01-05 ~ 01-11)"
      const weekMatch = summaryDateStart.match(/^(\d{4})W(\d{2})$/)

      if (weekMatch) {
        const year = parseInt(weekMatch[1])

        const match = item.text.match(
          /\((\d{2}-\d{2})\s~\s(\d{2}-\d{2})\)/
        )

        if (match) {
          const [, startStr, endStr] = match

          startTime = new Date(`${year}-${startStr}`)
          endTime = new Date(`${year}-${endStr}`)
        }
      }

      return {
        startTime: this.formatDate(startTime),
        endTime: this.formatDate(endTime)
      }
    },
    uploadTestFile (event) {
      const file = event.target.files[0]
      const formData = new FormData()
      console.log(file)
      formData.append('file', file)
      // formData.append('vendorCode', this.summaryFactory)
      formData.append('vendorCode', 'JT-NJ')
      this.$http.post(
        `/api/ctq-schedule/file/uploadFile`,
        formData
      )
        .then(res => {
          const result = res.data

          const status = result.status
          const data = result.data

          if (status === 'success') {
            this.snackbar = true
            this.snackbarColor = 'red'
            this.snackbarMsg = data
          } else {
            console.error('失败:', result.errMsg)
          }
        })
        .catch(err => {
          console.error('请求异常:', err)
        })
    },
    formatDate (date) {
      if (!date) return null

      const pad = (n) => String(n).padStart(2, '0')

      const y = date.getFullYear()
      const m = pad(date.getMonth() + 1)
      const d = pad(date.getDate())

      return `${y}-${m}-${d}`
    }
  }
}
</script>
<style>
/* .c3-axis-x .tick tspan:hover {
  cursor: pointer;
} */

.text-center {
  text-align: center !important;
}
</style>
